import { useApiClientStore } from '../stores/useApiClientStore';
import {
  ApiResult,
  AuthenticateUsingNhsAppIdentityResult,
  NhsLoginAuthorizeResult,
  RequestTypeShort,
} from '../types';
import type { ApiResponseRaw, NhsLoginAuthorizeResponse } from '../types';

export async function fetchNhsLoginUrlApi(
  requestType: RequestTypeShort,
  assertedLoginIdentity?: string,
): Promise<ApiResponseRaw<NhsLoginAuthorizeResponse>> {
  const api = useApiClientStore().getClient();
  const params = new URLSearchParams({
    requestType,
  });

  if (assertedLoginIdentity) {
    params.append('assertedLoginIdentity', assertedLoginIdentity);
  }

  return await api.getRaw<NhsLoginAuthorizeResponse>(
    `/patient-portal/get-nhs-login-authorize-request?${params.toString()}`
  );
}

export async function verifyNhsLoginApi(code: string) {
  const api = useApiClientStore().getClient();
  return await api.postRaw<NhsLoginAuthorizeResult>(
    '/patient-portal/session/authenticate-using-nhs-login-code',
    {
      code,
    },
  );
}

export async function authenticateUsingNhsAppIdentity(code: string, requestType: RequestTypeShort) {
  const api = useApiClientStore().getClient();
  return  await api.postRaw<AuthenticateUsingNhsAppIdentityResult>(
    "/patient-portal/session/authenticate-using-nhs-app-identity",
    { code, requestType }
  );
}

export async function authenticateUsingNhsAppPatientIdentity(jwtToken: string) {
  const api = useApiClientStore().getClient();
  return await api.postRaw<ApiResult>(
    '/patient-portal/session/authenticate-using-nhs-app-patient-identity',
    null,
    {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    }
  );
}
